import './white-paper-download-panel';
import './white-paper-download-panel.pcss';